export const loadState = () => {
  // We need the try block because user may not permit our accessing localStorage.
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      // The key 'state' does not exist.
      return undefined; // Let our reducer initialize the app.
    }

    return JSON.parse(serializedState);
  } catch (error) {
    console.log(error);
    return undefined; // Let our reducer initialize the app.
  }
};

export const saveState = data => {
  try {
    // Serialize the state. Redux store is recommended to be serializable.
    const serializedState = JSON.stringify(data);
    localStorage.setItem("state", serializedState);
  } catch (error) {
    console.log(error);
  }
};

export const getSelectedDate = () => {
  let temporaryDate = localStorage.getItem("temporaryDate");
  if (!temporaryDate) {
    return "";
  }

  let temporaryArray = temporaryDate.split(" ")[0].split("-");
  temporaryArray = temporaryArray.map(element => parseInt(element));
  let currentDate = new Date();

  if (temporaryArray[2] < currentDate.getFullYear()) {
    return "";
  }

  if (temporaryArray[1] < currentDate.getMonth() + 1) {
    return "";
  }

  if (temporaryArray[0] < currentDate.getDate()) {
    return "";
  }

  return temporaryDate;
};



// WEBPACK FOOTER //
// ./src/store/persistState.js